import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/main.scss";
import Header from "./common/Header";
import SiderBar from "./common/SiderBar";
import { Calendar } from "antd";
import dayjs from "dayjs";
import useAuth from "../hooks/useAuth";
import Cookies from "js-cookie";
import { setAPIAuthorizationToken } from "../apis/API";

const Main = () => {
  const navigate = useNavigate();
  // 验证用户登录状态
  useAuth();

  // 初始化token
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setAPIAuthorizationToken(token);
    }
  }, []);

  // 侧边栏折叠状态
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleMenuToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [hideAmount, setHideAmount] = useState(false);
  const [fromCurrency, setFromCurrency] = useState("USD");
  const [toCurrency, setToCurrency] = useState("CNH");
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [exchangeRate] = useState("7.1006");
  const [selectedPeriod, setSelectedPeriod] = useState("today");
  const [showTodoSection, setShowTodoSection] = useState(true);
  const [showHolidaySection, setShowHolidaySection] = useState(true);
  const [showUnauthorizedModal, setShowUnauthorizedModal] = useState(false);
  const [calendarValue] = useState(dayjs()); // 固定日历值，不允许改变

  const currencies = [
    { code: "EUR", name: "EUR", flag: "/home/m3-4.svg" },
    { code: "GBP", name: "GBP", flag: "/home/m3-5.svg" },
    { code: "CNY", name: "CNY", flag: "/home/m3-1.svg" },
    { code: "CNH", name: "CNH", flag: "/home/m3-1.svg" },
    { code: "HKD", name: "HKD", flag: "/home/m3-9.svg" },
    { code: "PLN", name: "PLN", flag: "/home/m3-13.svg" },
    { code: "KRW", name: "KRW", flag: "/home/m3-14.svg" },
    { code: "AUD", name: "AUD", flag: "/home/m3-6.svg" },
    { code: "CAD", name: "CAD", flag: "/home/m3-7.svg" },
    { code: "DKK", name: "DKK", flag: "/home/m3-15.svg" },
    { code: "VND", name: "VND", flag: "/home/m3-16.svg" },
    { code: "JPY", name: "JPY", flag: "/home/m3-8.svg" },
    { code: "THB", name: "THB", flag: "/home/m3-17.svg" },
    { code: "PHP", name: "PHP", flag: "/home/m3-18.svg" },
    { code: "IDR", name: "IDR", flag: "/home/m3-19.svg" },
    { code: "SGD", name: "SGD", flag: "/home/m3-10.svg" },
    { code: "MYR", name: "MYR", flag: "/home/m3-20.svg" },
    { code: "USD", name: "USD", flag: "/home/m3-2.svg" },
  ];

  //快捷导航
  const quickNavItems = [
    { icon: "/home/m1-1.png", label: "申请收款账户", link: "/apply-account" },
    { icon: "/home/m1-2.png", label: "发起付款" },
    { icon: "/home/m1-3.png", label: "入账订单", link: "/incoming-orders" },
    { icon: "/home/m1-4.png", label: "资金划拨" },
    { icon: "/home/m1-5.png", label: "商户问转账" },
    { icon: "/home/m1-6.png", label: "更多服务" },
  ];

  //展开隐藏
  const assetActions = [
    {
      label: hideAmount ? "展示" : "隐藏",
      icon: hideAmount ? "/home/m2-4.svg" : "/home/m2-1.svg",
      onClick: () => setHideAmount(!hideAmount),
    },
    {
      label: "我的资产",
      icon: "/home/m2-2.png",
      onClick: () => setShowUnauthorizedModal(true),
    },
    {
      label: "币种设置",
      icon: "/home/m2-3.svg",
      onClick: () => setShowUnauthorizedModal(true),
    },
  ];

  //待办事项
  const todoItems = [
    {
      badge: 1,
      content: (
        <>
          您有 <span className="todo-count">3</span> 个 店铺还未补传资料
        </>
      ),
      action: "去补传",
    },
    {
      badge: 2,
      content: "请绑定邮箱，以便用更完整的...",
      action: "去绑定",
    },
  ];

  //假期一览
  const holidays = [
    {
      date: "2025/10/23",
      desc: "柬国假期，有关站点入账延迟,出款延迟对应地区的打款也会有所延迟",
    },
    {
      date: "2025/10/27",
      desc: "新西兰假期，有关站点入账延迟,出款延迟对应地区的打款也会有所延迟",
    },
    {
      date: "2025/10/28",
      desc: "捷克假期，有关站点入账延迟,出款延迟对应地区的打款也会有所延迟",
    },
  ];

  //资产卡片
  const currencyCards = [
    { code: "CNY", name: "CNY 人民币", flag: "/home/m3-1.svg" },
    { code: "CNH", name: "CNH 离岸人民币", flag: "/home/m3-1.svg" },
    { code: "USD", name: "USD 美元", flag: "/home/m3-2.svg" },
    { code: "EUR", name: "EUR 欧元", flag: "/home/m3-4.svg" },
    { code: "GBP", name: "GBP 英镑", flag: "/home/m3-5.svg" },
    { code: "AUD", name: "AUD 澳元", flag: "/home/m3-6.svg" },
    { code: "CAD", name: "CAD 加元", flag: "/home/m3-7.svg" },
    { code: "JPY", name: "JPY 日元", flag: "/home/m3-8.svg" },
    { code: "HKD", name: "HKD 港币", flag: "/home/m3-9.svg" },
    { code: "SGD", name: "SGD 新加坡元", flag: "/home/m3-10.svg" },
    { code: "CHF", name: "CHF 瑞郎", flag: "/home/m3-11.svg" },
    { code: "NZD", name: "NZD 新币", flag: "/home/m3-12.svg" },
  ];

  const displayedCurrencies = showAllCurrencies
    ? currencyCards
    : currencyCards.slice(0, 3);

  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency);
    setShowCurrencyDropdown(false);
  };

  return (
    <div className="main-container">
      <Header
        onMenuToggle={handleMenuToggle}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <div className="main-content-wrapper">
        <SiderBar isCollapsed={isSidebarCollapsed} />

        <main
          className={`main-content ${
            isSidebarCollapsed ? "sidebar-collapsed" : ""
          }`}
        >
          {/* 快捷导航 */}
          <section className="quick-nav">
            <h2 className="section-title">快捷导航</h2>
            <div className="quick-nav-grid">
              {quickNavItems.map((item, index) => (
                <div
                  key={index}
                  className="quick-nav-item"
                  onClick={() => {
                    if (item.link) {
                      navigate(item.link);
                    } else {
                      setShowUnauthorizedModal(true);
                    }
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div className="nav-icon">
                    <img alt="" src={item.icon} />
                  </div>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </section>

          {/* 总资产 */}
          <section className="total-assets">
            <div className="assets-header">
              <div className="assets-title">
                <h2>总资产</h2>
                <span className="assets-subtitle">
                  (根据实时汇率估算的当前账户的总余额，仅供参考)
                </span>
              </div>
              <div className="assets-actions">
                {assetActions.map((action, index) => (
                  <button
                    key={index}
                    className="action-btn"
                    onClick={action.onClick}
                  >
                    <span>{action.label}</span>
                    <img alt="" src={action.icon} />
                  </button>
                ))}
              </div>
            </div>

            <div className="assets-amount">
              <span className="currency-symbol">≈</span>
              <div className="currency-selector">
                <button
                  className="currency-dropdown-btn"
                  onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                >
                  <span className="amount">
                    {hideAmount ? "**** " : "0 "}
                    {selectedCurrency}
                  </span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className={showCurrencyDropdown ? "rotate" : ""}
                  >
                    <path
                      d="M4 6l4 4 4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </button>
                {showCurrencyDropdown && (
                  <div className="currency-dropdown">
                    {currencies.map((currency) => (
                      <div
                        key={currency.code}
                        className={`currency-option ${
                          selectedCurrency === currency.code ? "active" : ""
                        }`}
                        onClick={() => handleCurrencySelect(currency.code)}
                      >
                        <img
                          className="currency-option-flag"
                          alt=""
                          src={currency.flag}
                        />
                        <span>{currency.name}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* 币种卡片容器 */}
            <div className="currency-container">
              {/* 币种卡片网格 */}
              <div className="currency-grid">
                {displayedCurrencies.map((currency) => (
                  <div key={currency.code} className="currency-card">
                    <div className="currency-header">
                      <img
                        className="currency-flag"
                        alt=""
                        src={currency.flag}
                      />
                      <span className="currency-name">{currency.name}</span>
                    </div>
                    <div className="currency-balance">
                      {hideAmount ? "****" : "0"}
                    </div>
                    <div className="currency-actions">
                      <button className="btn-primary">提现</button>
                      <button className="btn-secondary">付款</button>
                    </div>
                  </div>
                ))}
              </div>

              {/* 展开/收起按钮 */}
              <div
                className="expand-more-card"
                onClick={() => setShowAllCurrencies(!showAllCurrencies)}
              >
                <div className="expand-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className={showAllCurrencies ? "rotate-up" : ""}
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="#4F3DF5"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 10l4 4 4-4"
                      stroke="#4F3DF5"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span className="expand-text">
                  {showAllCurrencies ? "收起" : "展开更多"}
                </span>
              </div>
            </div>
          </section>

          {/* 实时汇率 */}
          <section className="exchange-rate-section">
            <div className="exchange-rate-header">
              <div className="exchange-rate-title">
                <h2>实时汇率</h2>
                <span className="update-time">
                  更新于 2025-10-30 19:17:12数据仅供参考 🔄
                </span>
              </div>
              <button className="more-link">查询更多汇率 &gt;</button>
            </div>

            <div className="exchange-calculator">
              {/* 左侧货币选择器 */}
              <div className="currency-input-group">
                <div
                  className="currency-select-wrapper"
                  onBlur={(e) => {
                    // 检查失焦目标是否在当前元素内
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                      setShowFromDropdown(false);
                    }
                  }}
                  tabIndex={-1}
                >
                  <button
                    className="currency-select-btn"
                    onClick={() => setShowFromDropdown(!showFromDropdown)}
                  >
                    <img
                      alt=""
                      src={
                        currencies.find((c) => c.code === fromCurrency)?.flag
                      }
                      className="currency-flag-small"
                    />
                    <span>{fromCurrency}</span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path
                        d="M4 6l4 4 4-4"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </button>
                  {showFromDropdown && (
                    <div className="currency-dropdown-small">
                      {currencies.map((currency) => (
                        <div
                          key={currency.code}
                          className={`currency-option ${
                            fromCurrency === currency.code ? "active" : ""
                          }`}
                          onClick={() => {
                            setFromCurrency(currency.code);
                            setShowFromDropdown(false);
                          }}
                        >
                          <img
                            className="currency-option-flag"
                            alt=""
                            src={currency.flag}
                          />
                          <span>{currency.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  className="amount-input"
                  placeholder="请输入金额"
                />
              </div>

              {/* 中间交换图标 */}
              <button
                className="swap-btn"
                onClick={() => {
                  const temp = fromCurrency;
                  setFromCurrency(toCurrency);
                  setToCurrency(temp);
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 16L3 12L7 8"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3 12H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17 8L21 12L17 16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 12H7"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {/* 右侧货币选择器 */}
              <div className="currency-input-group">
                <div
                  className="currency-select-wrapper"
                  onBlur={(e) => {
                    // 检查失焦目标是否在当前元素内
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                      setShowToDropdown(false);
                    }
                  }}
                  tabIndex={-1}
                >
                  <button
                    className="currency-select-btn"
                    onClick={() => setShowToDropdown(!showToDropdown)}
                  >
                    <img
                      alt=""
                      src={currencies.find((c) => c.code === toCurrency)?.flag}
                      className="currency-flag-small"
                    />
                    <span>{toCurrency}</span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path
                        d="M4 6l4 4 4-4"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </button>
                  {showToDropdown && (
                    <div className="currency-dropdown-small">
                      {currencies.map((currency) => (
                        <div
                          key={currency.code}
                          className={`currency-option ${
                            toCurrency === currency.code ? "active" : ""
                          }`}
                          onClick={() => {
                            setToCurrency(currency.code);
                            setShowToDropdown(false);
                          }}
                        >
                          <img
                            className="currency-option-flag"
                            alt=""
                            src={currency.flag}
                          />
                          <span>{currency.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  className="amount-input"
                  placeholder="请输入金额"
                />
              </div>
            </div>

            {/* 常用汇率和图表容器 */}
            <h3 className="section-title-outside">常用汇率</h3>
            <div className="exchange-content-wrapper">
              {/* 常用汇率 */}
              <div className="common-rates-wrapper">
                <div className="common-rates">
                  <div className="rates-empty">
                    <img alt="暂无数据" src="/home/m4.png" />
                    暂无数据
                  </div>
                </div>
              </div>

              {/* 汇率图表 */}
              <div className="exchange-chart-wrapper">
                <div className="chart-header">
                  <div className="current-rate">
                    <span className="rate-label">
                      1 {fromCurrency} = {exchangeRate} {toCurrency}
                    </span>
                  </div>
                  <div className="period-tabs">
                    <button
                      className={selectedPeriod === "today" ? "active" : ""}
                      onClick={() => setSelectedPeriod("today")}
                    >
                      今天
                    </button>
                    <button
                      className={selectedPeriod === "7days" ? "active" : ""}
                      onClick={() => setSelectedPeriod("7days")}
                    >
                      近7天
                    </button>
                    <button
                      className={selectedPeriod === "30days" ? "active" : ""}
                      onClick={() => setSelectedPeriod("30days")}
                    >
                      近30天
                    </button>
                  </div>
                </div>
                <div className="chart-container">
                  <svg
                    width="100%"
                    height="300"
                    viewBox="0 0 1200 300"
                    preserveAspectRatio="none"
                  >
                    {/* 背景网格线 */}
                    <line
                      x1="0"
                      y1="50"
                      x2="1200"
                      y2="50"
                      stroke="#e8eaec"
                      strokeWidth="1"
                    />
                    <line
                      x1="0"
                      y1="100"
                      x2="1200"
                      y2="100"
                      stroke="#e8eaec"
                      strokeWidth="1"
                    />
                    <line
                      x1="0"
                      y1="150"
                      x2="1200"
                      y2="150"
                      stroke="#e8eaec"
                      strokeWidth="1"
                    />
                    <line
                      x1="0"
                      y1="200"
                      x2="1200"
                      y2="200"
                      stroke="#e8eaec"
                      strokeWidth="1"
                    />
                    <line
                      x1="0"
                      y1="250"
                      x2="1200"
                      y2="250"
                      stroke="#e8eaec"
                      strokeWidth="1"
                    />

                    {/* 汇率曲线 */}
                    <path
                      d="M 40 230 L 80 235 L 120 220 L 160 210 L 200 195 L 240 180 L 280 175 L 320 185 L 360 190 L 400 180 L 440 175 L 480 185 L 520 180 L 560 175 L 600 170 L 640 160 L 680 155 L 720 150 L 760 145 L 800 135 L 840 125 L 880 115 L 920 105 L 960 95 L 1000 85 L 1040 75 L 1080 65 L 1120 55 L 1160 45"
                      fill="none"
                      stroke="#4f3df5"
                      strokeWidth="2"
                    />

                    {/* 填充区域 */}
                    <path
                      d="M 40 230 L 80 235 L 120 220 L 160 210 L 200 195 L 240 180 L 280 175 L 320 185 L 360 190 L 400 180 L 440 175 L 480 185 L 520 180 L 560 175 L 600 170 L 640 160 L 680 155 L 720 150 L 760 145 L 800 135 L 840 125 L 880 115 L 920 105 L 960 95 L 1000 85 L 1040 75 L 1080 65 L 1120 55 L 1160 45 L 1160 300 L 40 300 Z"
                      fill="url(#gradient)"
                      opacity="0.3"
                    />

                    {/* 渐变定义 */}
                    <defs>
                      <linearGradient
                        id="gradient"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop
                          offset="0%"
                          style={{ stopColor: "#4f3df5", stopOpacity: 0.4 }}
                        />
                        <stop
                          offset="100%"
                          style={{ stopColor: "#4f3df5", stopOpacity: 0 }}
                        />
                      </linearGradient>
                    </defs>
                  </svg>

                  {/* Y轴标签 */}
                  <div className="y-axis-labels">
                    <span>7.1122</span>
                    <span>7.1100</span>
                    <span>7.1050</span>
                    <span>7.1000</span>
                    <span>7.0950</span>
                    <span>7.0900</span>
                    <span>7.0850</span>
                    <span>7.0800</span>
                  </div>

                  {/* X轴标签 */}
                  <div className="x-axis-labels">
                    <span>00:00</span>
                    <span>01:30</span>
                    <span>03:00</span>
                    <span>04:30</span>
                    <span>06:00</span>
                    <span>07:30</span>
                    <span>09:00</span>
                    <span>10:30</span>
                    <span>12:00</span>
                    <span>13:30</span>
                    <span>15:00</span>
                    <span>16:30</span>
                    <span>18:00</span>
                    <span>19:30</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <aside className="right-panel">
          {/* 待办事项 */}
          <section className="todo-section">
            <div className="section-header">
              <h3>待办事项</h3>
              <button
                className={`collapse-btn ${showTodoSection ? "" : "collapsed"}`}
                onClick={() => setShowTodoSection(!showTodoSection)}
              >
                <span>{showTodoSection ? "隐藏" : "显示"}</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  style={{
                    transform: showTodoSection
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </button>
            </div>
            {showTodoSection && (
              <div className="todo-list">
                {todoItems.map((item) => (
                  <div key={item.badge} className="todo-item">
                    <div className="todo-badge">{item.badge}</div>
                    <div className="todo-content">{item.content}</div>
                    <button
                      className="todo-action"
                      onClick={() => setShowUnauthorizedModal(true)}
                    >
                      {item.action}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </section>

          {/* 假期一览 */}
          <section className="holiday-section">
            <div className="section-header">
              <h3>假期一览</h3>
              <button
                className={`collapse-btn ${
                  showHolidaySection ? "" : "collapsed"
                }`}
                onClick={() => setShowHolidaySection(!showHolidaySection)}
              >
                <span>{showHolidaySection ? "隐藏" : "显示"}</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  style={{
                    transform: showHolidaySection
                      ? "rotate(0deg)"
                      : "rotate(180deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </button>
            </div>

            {showHolidaySection && (
              <>
                <div className="calendar">
                  <Calendar
                    fullscreen={false}
                    value={calendarValue}
                    onSelect={(date) => {
                      // 阻止日期选择，显示未授权提示
                      setShowUnauthorizedModal(true);
                    }}
                    onPanelChange={(date, mode) => {
                      // 阻止面板切换（月份/年份切换），显示未授权提示
                      setShowUnauthorizedModal(true);
                    }}
                  />
                </div>

                <div className="holiday-list">
                  {holidays.map((holiday, index) => (
                    <div key={index} className="holiday-item">
                      <div className="holiday-marker">I</div>
                      <div className="holiday-info">
                        <div className="holiday-date">{holiday.date}</div>
                        <div className="holiday-desc">{holiday.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </section>
        </aside>
      </div>
      <footer className="page-footer">
        <p>© 2022 GLOBAL E-PAYMENT LIMITED. All Rights Reserved.</p>
      </footer>

      {/* 未授权访问模态框 */}
      {showUnauthorizedModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowUnauthorizedModal(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">🔒</div>
            <h3 className="modal-title">未授权访问</h3>
            <p className="modal-message">您暂时无权访问此功能</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Main;
